/**
 * List of properties read separately from product with fallback to options to set up various application behaviour
 */
export class ViewConfig {
	public navigator = null;
	public transform = null;
}

export class ViewConfigInt extends ViewConfig {
	append(config: ViewConfig){
		for (let p of Object.getOwnPropertyNames(this))
			if (!this[p] && config[p])
				this[p] = config[p];
	}
}



// WEBPACK FOOTER //
// ./src/script/app3D/config/ViewConfig.ts